<script setup lang="ts">
    /**
     * @deprecated use IntroWidget.vue
     */
    import type { ContentHeaderData } from '~/@types/cms';
    import type { IWidgetProps } from '~/composables/widgets';

    defineProps<IWidgetProps<ContentHeaderData>>();
</script>
<template>
    <mol-intro :intro="data" />
</template>
